<template>
    <div v-if="$route.name !== 'login' && !mainLoading" class="main-view">
        <nav class="main-view__nav" :class="{ minimised : minimisedMenu }">
            <div class="main-view__nav-inner">
                <div @click="expandMenu" class="header__mobile-menu">
                    <span></span>
                </div>
                <router-link to="/">
                    <div class="site-logo">
                        <img alt="Top Style Media" src="../src/assets/logo.png">
                    </div>
                </router-link>
                <div v-if="user_data.profile_picture" class="header__mobile-profile-photo">
                    <img alt="profile image" :src="user_data.profile_picture">
                </div>
                <ul class="main-view__nav--menu" :class="{ open : mobileMenuOpen }">
                    <li class="dashboard">
                        <router-link class="active" to="/">
                            <translation en="Dashboard" ch="仪表板"></translation>
                        </router-link>
                    </li>
                    <li class="campaigns">
                        <router-link to="/campaigns">
                            <translation en="Campaigns" ch="活动"></translation>
                        </router-link>
                    </li>
                    <li class="reports">
                        <router-link to="/reports">
                            <translation en="Reports" ch="报告"></translation>
                        </router-link>
                    </li>
                    <li class="payments">
                        <router-link to="/payments">
                            <translation en="Payments" ch="付款方式"></translation>
                        </router-link>
                    </li>
                    <li class="widgets">
                        <router-link to="/widgets">
                            <translation en="Widgets & links" ch="小部件和链接"></translation>
                        </router-link>
                    </li>
                    <li class="return-to-site">
                        <a href="https://topstylemedia.com">
                            <translation en="Return to website" ch="返回网站"></translation>
                        </a>
                    </li>
                    <li class="help">
                        <router-link to="/help">
                            <translation en="Help & Support" ch="帮助支持"></translation>
                        </router-link>
                    </li>
                    <li class="admin">
                        <router-link class="active" to="/admin">
                            <translation en="Visit admin area" ch="访问管理区"></translation>
                        </router-link>
                    </li>
                    <li class="logout">
                        <a @click="logout">
                            <translation en="Logout" ch="登出"></translation>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    
        <div v-if="!mainLoading" class="main-view__content">
            <header class="main-view__header" :class="{ scrolled : windowScrolled }">
                <div class="header__menu">
                    <span @click="minimiseMenu"></span>
                </div>
                <div class="header__breadcrumbs">
                    <breadcrumbs :current="this.currentRoute"></breadcrumbs>
                </div>
                <div class="header__search">
                    <div class="search-box">
                        <input type="text" v-on:blur="closeGlobalSearch" v-model="searchTerm" @input="openGlobalSearch" :placeholder="this.$translation('Search campaigns', '搜索广告系列')" class="title">
                        <span class="search-box__submit"></span>
                        <div v-if="searchOpen" class="search-box__results">
                            <loading v-if="searchLoading" size="small" :loading="searchLoading"></loading>
                            <div v-for="searchResult in searchResults" v-if="!searchLoading">
                                <search-card :campaign="searchResult"></search-card>
                            </div>
                        </div>
                    </div>
                </div>
                <router-link to="/edit-profile" class="header__profile">
                    <div v-if="user_data.profile_picture" class="header__profile-photo">
                        <img alt="profile image" :src="user_data.profile_picture">
                    </div>
                    <div class="header__profile-details">
                        <span>
                               {{ user_data.first_name }} {{ user_data.last_name }}
                            </span>
                    </div>
                </router-link>
            </header>
            <div class="main-view__content-area">
                <loading :loading="loading" size="page"></loading>
                <router-view v-if="!loading" />
                <footer v-if="!loading" class="main-footer">
                    <ul>
                        <li>
                            <router-link to="/terms-and-conditions">Terms and Conditions</router-link>
                        </li>
                        <li>Top Style Media 2026 &copy;</li>
                    </ul>
                </footer>
            </div>
        </div>
    </div>
    
    <div v-if="mainLoading" class="main-view">
        <div class="main-view__content">
            <div class="main-view__content-area">
                <loading :loading="mainLoading" size="page"></loading>
            </div>
        </div>
    </div>
    
    <router-view v-if="$route.name == 'login'" />
</template>


<script>
import Loading from "@/components/Loading";
import SearchCard from "@/components/SearchCard";
import Breadcrumbs from "@/components/Breadcrumbs";
import axios from 'axios';
import { useStore } from '@/store';
import Translation from "@/components/Translation.vue";
import { watch, computed } from 'vue';


export default {
    components: {
        Loading,
        SearchCard,
        Breadcrumbs,
        Translation
    },
    data() {
        return {
            auth: false,
            loading: true,
            windowScrolled: false,
            minimisedMenu: false,
            loggedIn: false,
            user_data: '',
            mainLoading: true,
            mobileMenuOpen: false,
            searchCampaigns: [],
            searchOpen: false,
            searchTerm: '',
            searchLoading: false,
            campaigns: [],
            searchResults: [],
            route_title: "",
        }
    },
    beforeMount() {},
    mounted() {

        const store = useStore();
        this.user_data = store.user_data;

        setTimeout(() => (
            this.mainLoading = false,
            this.loading = false
        ), 1000);

        window.addEventListener('scroll', this.handleScroll);

        if (this.$getSessionToken()) {
            this.loadSearchCampaigns();
        }

    },

    watch: {
        '$route': 'handleRouteChange',
    },


    methods: {

        update_user_data() {
            if (this.$getSessionToken()) {
                const store = useStore();
                this.user_data = store.user_data;
            }
        },

        get_user_data() {
            if (this.$getSessionToken()) {
                axios.get('https://apis.topstylemedia.com/index.php/wp-json/v1/user-data', {
                    headers: {
                        'Authorization': `Bearer ${this.$getSessionToken()}`,
                    }
                }).then(response => {
                    const store = useStore();
                    store.user_data = response.data;
                    this.user_data = store.user_data;
                    this.loggedIn = true;
                }).catch(error => {
                    this.$unauthorisedEndpoint();
                });
            }
        },

        loadSearchCampaigns() {

            const requestBody = {
                type: 'all',
            };

            axios
                .post('https://apis.topstylemedia.com/index.php/wp-json/v1/campaigns', requestBody, {
                    headers: {
                        'Authorization': `Bearer ${this.$getSessionToken()}`,
                    }
                })
                .then(
                    response => (this.searchCampaigns = response.data.campaigns),
                )
        },

        handleRouteChange(newRoute, oldRoute) {

            if (oldRoute.name === 'login') {
                this.get_user_data();
                this.loadSearchCampaigns();
            }

            const store = useStore();

            if (!store.user_data) {
                this.get_user_data();
            }

            this.mobileMenuOpen = false;
            this.loading = true;

            this.update_user_data();


            setTimeout(() => (
                this.loading = false
            ), 500);
        },


        runGlobalSearch() {

            if (this.searchTerm) {
                this.searchResults = this.searchCampaigns;
                let searchTerm = this.searchTerm.toLowerCase();
                let products = this.searchCampaigns;
                let exactMatches = [];
                let partialMatches = [];

                if (products != null) {
                    // First, get exact matches that start with the search term
                    exactMatches = products.filter(product =>
                        product.title.toLowerCase().startsWith(searchTerm)
                    );

                    // Then, get the rest of the matches that contain the search term
                    partialMatches = products.filter(product =>
                        !product.title.toLowerCase().startsWith(searchTerm) &&
                        product.title.toLowerCase().includes(searchTerm)
                    );
                }

                // Combine the exact matches with the partial matches
                this.searchResults = exactMatches.concat(partialMatches);
                this.searchLoading = false;
            } else {
                this.searchLoading = false;
            }

        },

        expandMenu() {
            this.mobileMenuOpen = true
        },

        openGlobalSearch() {
            this.searchLoading = true;
            this.searchOpen = true;

            this.runGlobalSearch()

        },


        closeGlobalSearch() {
            setTimeout(() => (
                this.searchOpen = false,
                this.searchTerm = ''
            ), 100);
        },

        logout() {
            this.loading = true;
            this.$removeSessionToken();
            setTimeout(() => (
                this.$router.push('/login')
            ), 1000);
        },

        minimiseMenu() {
            this.minimisedMenu = this.minimisedMenu === false;
        },


        handleScroll() {
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;
            if (scrollPosition > 91) {
                this.windowScrolled = true
            } else {
                this.windowScrolled = false
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
        document.title = "Top Style Media - Dashboard";
    },
    computed: {
        currentRoute() {
            return this.$route;
        }
    },
}
</script>




<style lang="scss">
@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "scss/styles.scss";
.main-view {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    @include bp(md) {
        flex-wrap: nowrap;
    }
    &__content-area {
        padding: 2rem 1.5rem 0 1.5rem;
        display: flex;
        flex-wrap: wrap;
        @include bp(md) {
            padding: 4rem 4rem 0 4rem;
            min-height: calc(100% - 9.1rem);
        }
    }
    .header {
        &__mobile-menu {
            width: 4rem;
            height: 3.2rem;
            background-size: 2.6rem;
            background-repeat: no-repeat;
            background-position: left center;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM192 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H176c8.8 0 16 7.2 16 16z'/%3E%3C/svg%3E");
            &:hover {
                cursor: pointer;
            }
            @include bp(md) {
                display: none;
            }
        }
        &__mobile-profile-photo {
            width: 4rem;
            height: 4rem;
            border-radius: 50%;
            overflow: hidden;
            background-color: #eee;
            @include bp(md) {
                display: none;
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
            }
        }
    }
    &__header {
        display: none;
        @include bp(md) {
            background-color: white;
            box-shadow: 0 2px 6px #2553b91a;
            display: flex;
            justify-content: space-between;
            padding: 1.8rem 3.5rem;
            position: sticky;
            transition: 0.3s;
            top: 0;
            z-index: 9;
        }
        .header {
            &__breadcrumbs {
                padding-left: 3.5rem;
                display: none;
                align-items: center;
                @include bp(lg) {
                    display: flex;
                }
            }
            &__menu {
                display: flex;
                align-content: center;
                align-items: center;
                span {
                    width: 2.2rem;
                    height: 2.2rem;
                    display: block;
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath d='M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM192 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H168c13.3 0 24 10.7 24 24z'/%3E%3C/svg%3E");
                    &:hover {
                        cursor: pointer;
                    }
                }
            }
            &__search {
                margin-right: 4.5rem;
                align-items: center;
                display: flex;
                align-content: center;
                flex: 1;
                justify-content: flex-end;
            }
            &__profile {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                &-photo {
                    width: 5.5rem;
                    height: 5.5rem;
                    border-radius: 50%;
                    background-color: #eee;
                    margin-right: 1.4rem;
                    transition: 0.3s;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        object-position: center;
                        border-radius: 50%;
                    }
                }
                &-details {
                    display: flex;
                    flex-wrap: wrap;
                    font-weight: 500;
                }
            }
        }
        &.scrolled {
            transition: 0.3s;
            padding: 1rem 3.5rem;
            .header__profile-photo {
                width: 4.5rem;
                height: 4.5rem;
                transition: 0.3s;
            }
        }
    }
    &__nav {
        width: 100%;
        position: relative;
        transition: 0.4s;
        @include bp(md) {
            width: 22rem;
            height: 100%;
        }
        @include bp(lg) {
            width: 24rem;
        }
        &-inner {
            background-color: $darkblue;
            padding: 1rem 1.5rem;
            height: 100%;
            width: 100%;
            transition: 0.4s;
            display: flex;
            align-items: center;
            justify-content: space-between;
            @include bp(md) {
                display: flex;
                flex-wrap: wrap;
                width: 22rem;
                align-items: flex-start;
                align-content: flex-start;
                position: fixed;
                left: 0;
                padding: 2.8rem 3rem;
            }
            @include bp(lg) {
                width: 24rem;
            }
        }
        &.minimised {
            width: 8rem;
            transition: 0.4s;
            .main-view__nav-inner {
                width: 8rem;
                transition: 0.4s;
                padding: 2.8rem 1.8rem;
                ul {
                    li {
                        padding: 0;
                        background-position: center center;
                        a {
                            text-indent: -99999px;
                        }
                    }
                }
            }
        }
        .site-logo {
            width: 10rem;
            display: flex;
            @include bp(md) {
                width: 100%;
            }
        }
        ul {
            margin-top: 4rem;
            display: none;
            @include bp(md) {
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
                align-items: flex-start;
                align-content: flex-start;
                flex-grow: 1;
            }
            li {
                margin: 0.6rem 0;
                background-repeat: no-repeat;
                background-position: left center;
                padding-left: 3.2rem;
                background-size: 1.8rem;
                &.admin{
                  @include bp(md){
                    flex-grow: 1;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: flex-end;
                    align-content: flex-end;
                    background-size: 1.6rem;
                    background-position-x: 2px;
                    background-position-y: calc(100% - 5px);
                    margin-top: 3.3rem;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 640'%3E%3C!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M400 416C497.2 416 576 337.2 576 240C576 142.8 497.2 64 400 64C302.8 64 224 142.8 224 240C224 258.7 226.9 276.8 232.3 293.7L71 455C66.5 459.5 64 465.6 64 472L64 552C64 565.3 74.7 576 88 576L168 576C181.3 576 192 565.3 192 552L192 512L232 512C245.3 512 256 501.3 256 488L256 448L296 448C302.4 448 308.5 445.5 313 441L346.3 407.7C363.2 413.1 381.3 416 400 416zM440 160C462.1 160 480 177.9 480 200C480 222.1 462.1 240 440 240C417.9 240 400 222.1 400 200C400 177.9 417.9 160 440 160z'/%3E%3C/svg%3E");
                  }
                }
                &.return-to-site {
                    background-size: 1.6rem;
                    background-position-x: 2px;
                    margin-top: 3.3rem;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M177.5 66c-8.8-3.8-19-2-26 4.6l-144 136C2.7 211.1 0 217.4 0 224s2.7 12.9 7.5 17.4l144 136c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-88 192 0c17.7 0 32 14.3 32 32l0 144c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-144c0-70.7-57.3-128-128-128l-192 0 0-88c0-9.6-5.7-18.2-14.5-22z'/%3E%3C/svg%3E");
                }
                &.payments {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'%3E%3C!--!Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M32 96V416H544V96H32zM0 64H32 544h32V96 416v32H544 32 0V416 96 64zM480 288v32H256V288H480zM256 192H480v32H256V192zm-96-32v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2 0 0c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V352v16H128V352v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V160 144h32v16z'/%3E%3C/svg%3E");
                }
                &.dashboard {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'/%3E%3C/svg%3E");
                }
                &.campaigns {
                    background-size: 1.6rem;
                    background-position-x: 2px;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M89.3 156.3C113 115 143.2 77 170.5 50.4c18.7 18.7 40.9 47.2 60.1 71.7c3.8 4.8 7.4 9.5 10.9 13.9c4.6 5.8 11.7 9.2 19.1 9.1s14.4-3.6 18.9-9.5c3.3-4.3 7.7-10.8 12.3-17.4c2.6-3.8 5.3-7.6 7.8-11.2c5.6-7.9 10.5-14.5 14.4-19.1c20 20.8 41 53 57.4 88.4c17.7 38.2 28.6 77 28.6 106.3c0 103-78.8 181.4-176 181.4c-98.3 0-176-78.4-176-181.4c0-37.5 16.2-82.4 41.3-126.2zM199.5 11.6C183.3-3.8 158-3.9 141.8 11.5c-32 30.1-67 73.6-94.1 121C20.7 179.5 0 233 0 282.6C0 410.9 98.1 512 224 512c124.6 0 224-100.9 224-229.4c0-39.1-13.9-85.2-33.1-126.5C395.7 114.6 369.8 74.9 343 49c-16.3-15.8-42-15.8-58.3-.1c-7.9 7.6-17 20-24.3 30.3l-1.1 1.6C240.6 57 218.4 29.5 199.5 11.6zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z'/%3E%3C/svg%3E");
                }
                &.reports {
                    background-size: 1.6rem;
                    background-position-x: 2px;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v8V80 304v48V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H48V24zm0 56H376l-62.4 83.2c-12.8 17.1-12.8 40.5 0 57.6L376 304H48V80z'/%3E%3C/svg%3E");
                }
                &.help {
                    background-size: 1.6rem;
                    background-position-x: 2px;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'/%3E%3C/svg%3E");
                }
                &.widgets {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z'/%3E%3C/svg%3E");
                }
                a {
                    color: white;
                    text-decoration: none;
                    position: relative;
                    z-index: 1;
                    display: block;
                    white-space: pre;
                    &:hover {
                        color: $aqua;
                        transition: 0.2s;
                    }
                }
            }
            &.open {
                position: fixed;
                display: block;
                top: 0;
                left: -25rem;
                background-color: $darkblue;
                width: 25rem;
                z-index: 99;
                height: 100%;
                margin: 0;
                animation: slideIn 0.5s ease-in-out forwards;
                padding: 5rem 2rem 2rem 2rem;
                @keyframes slideIn {
                    from {
                        left: -25rem;
                    }
                    to {
                        left: 0;
                    }
                }
            }
        }
    }
    &__content {
        flex: 1;
        height: 100%;
        @include bp(md) {
            width: calc(100vw - 22rem);
        }
        @include bp(lg) {
            width: calc(100vw - 24rem);
        }
    }
}

footer.main-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2.5rem;
    font-size: 1.1rem;
    padding-bottom: 2.5rem;
    color: $darkgrey;
    ul {
        display: flex;
        padding: 0;
        margin: 0;
        li {
            list-style-type: none;
            margin: 0 1rem;
            a {
                color: $darkblue;
                opacity: 0.8;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>


